module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_8011.99e89038.png";